import React from 'react';
import { Autocomplete, TextField, Box } from '@mui/material';
import commoditiesData from '../../data/commodities.json';

const CommodityAutocomplete = ({ value, onChange, disabled, label = "Commodity", placeholder = "Type number or name...", helperText, error, size = "small", fullWidth = true }) => {
  // Find the commodity object that matches the current value
  const selectedCommodity = commoditiesData.find(c => c.value === value) || null;

  const handleChange = (event, newValue) => {
    // newValue will be the commodity object or null
    onChange(newValue ? newValue.value : '');
  };

  return (
    <Autocomplete
      value={selectedCommodity}
      onChange={handleChange}
      options={commoditiesData}
      getOptionLabel={(option) => option.label}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <Box>
            <strong>{option.value}</strong> - {option.description}
          </Box>
        </Box>
      )}
      filterOptions={(options, { inputValue }) => {
        const input = inputValue.toLowerCase();
        return options.filter(option => 
          option.value.toLowerCase().includes(input) || 
          option.description.toLowerCase().includes(input)
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          helperText={helperText}
          error={error}
          variant="outlined"
        />
      )}
    />
  );
};

export default CommodityAutocomplete;